import React, { useState } from "react";
import { getValue } from "./utils";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import DynamicButton from "../DynamicButton/DynamicButton";
import "./TableRow.css";

const stop = (e) => e.stopPropagation();

// helper to render safe values
const renderCellValue = (val) => {
  if (!val) return "—";

  if (Array.isArray(val)) {
    return val
      .map((item) =>
        typeof item === "object"
          ? item?.name || item?.roleName || item?.projectName || item?._id
          : String(item)
      )
      .join(", ");
  }

  if (typeof val === "object") {
    return (
      val.name ||
      val.roleName ||
      val.projectName ||
      val._id ||
      JSON.stringify(val)
    );
  }

  return String(val);
};

const TableRow = ({
  row,
  index,
  currentPage,
  itemsPerPage,
  columns,
  editingRow,
  handleInputChange,
  handleSave,
  handleDelete,
  handleEdit,
  setEditingRow,
  selectedRows,
  toggleRowSelect,
  onRowClick,

  // 👇 pass from parent (model config)
  config = {},
}) => {
  const [showConfirm, setShowConfirm] = useState(false);

  const requestDelete = (e) => {
    stop(e);
    setShowConfirm(true);
  };

  const confirmDelete = () => {
    setShowConfirm(false);
    handleDelete(row._id);
  };

  const cancelDelete = () => setShowConfirm(false);

const getFileName = (url) => {
  try {
    return decodeURIComponent(url.split("/").pop().split("?")[0]);
  } catch {
    return "download";
  }
};

const handleDownload = () => {
  // Find ALL file columns
  const fileCols = columns.filter((c) => c.type === "file");
  if (!fileCols.length) {
    alert("No file column found");
    return;
  }

  let urls = [];
  fileCols.forEach((fileCol) => {
    const fileUrl = getValue(row, fileCol.field);
    if (fileUrl) {
      if (Array.isArray(fileUrl)) {
        urls = [...urls, ...fileUrl];
      } else {
        urls.push(fileUrl);
      }
    }
  });

  if (!urls.length) {
    alert("No file available for download");
    return;
  }

  // ✅ Open each file in Google Docs Viewer
  urls.forEach((url) => {
    const viewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(
      url
    )}&embedded=true`;

    const a = document.createElement("a");
    a.href = viewerUrl;
    a.target = "_blank"; // open in new tab
    a.rel = "noopener noreferrer";
    a.setAttribute("download", getFileName(url)); // optional: still hints filename

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  });
};


  return (
    <>
      <tr
        className={`custom-table-row ${
          selectedRows.includes(row._id) ? "selected" : ""
        }`}
        onClick={() => onRowClick && onRowClick(row)}
      >
        {/* Checkbox column */}
        <td onClick={stop} className="custom-table-row-checkbox">
          <input
            type="checkbox"
            checked={selectedRows.includes(row._id)}
            onChange={() => toggleRowSelect(row._id)}
          />
        </td>

        {/* Data columns */}
        {columns.slice(0, 6).map((col, colIndex) => {
          const rawVal = getValue(row, col.field);
          const displayVal = renderCellValue(rawVal);
          return (
            <td key={colIndex} className="custom-table-row-cell">
              {editingRow === index ? (
                <input
                  type="text"
                  className="custom-table-input"
                  value={rawVal || ""}
                  onChange={(e) => handleInputChange(e, index, col.field)}
                  onClick={stop}
                />
              ) : (
                displayVal
              )}
            </td>
          );
        })}

        {/* Action buttons */}
        <td className="custom-table-row-actions" onClick={stop}>
          <div className="custom-table-row-actions-inline">
            <DynamicButton
              icon="fa-edit"
              size="md"
              variant="primary"
              onClick={() => handleEdit(row._id)}
              title="Edit this record"
            />
            <DynamicButton
              icon="fa-trash"
              size="md"
              variant="danger"
              onClick={requestDelete}
              title="Delete this record"
            />

            {/* 👇 Conditionally render Download button */}
            {/* {config.DownloadButton === "true" && (
              <DynamicButton
                icon="fa-download"
                size="md"
                variant="outline"
                onClick={handleDownload}
                title="Download file(s)"
              />
            )} */}
          </div>
        </td>
      </tr>

      <ConfirmDialog
        open={showConfirm}
        title="Delete this record?"
        message="This action cannot be undone."
        confirmLabel="Delete"
        cancelLabel="Cancel"
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
        variant="danger"
      />
    </>
  );
};

export default TableRow;
